module.exports = __webpack_public_path__ + "img/newsletter-1.49bcdab1.svg";